/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wu_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is using a word unscrambler considered cheating?`)
};

const es_wu_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Se considera trampa usar un descifrador de palabras?`)
};

const de_wu_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gilt die Nutzung eines Wortentwirrers als Schummeln?`)
};

const nl_wu_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wordt het gebruik van een woordontwarraar als valsspelen beschouwd?`)
};

const fr_wu_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utiliser un déchiffreur de mots est-il considéré comme de la triche ?`)
};

const it_wu_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usare uno sblocca parole è considerato barare?`)
};

const pt_br2_wu_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usar um desembaralhador de palavras é considerado trapaça?`)
};

const pt_wu_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilizar um desbaralhador de palavras é considerado batota?`)
};

const ja_wu_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文字並べ替えツールを使うのは反則（チート）になりますか？`)
};

const zh_wu_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用字母重组工具算作弊吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wu_hub_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wu_hub_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wu_hub_faq4_q", locale)
	if (locale === "en") return en_wu_hub_faq4_q(inputs)
	if (locale === "es") return es_wu_hub_faq4_q(inputs)
	if (locale === "de") return de_wu_hub_faq4_q(inputs)
	if (locale === "nl") return nl_wu_hub_faq4_q(inputs)
	if (locale === "fr") return fr_wu_hub_faq4_q(inputs)
	if (locale === "it") return it_wu_hub_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_wu_hub_faq4_q(inputs)
	if (locale === "pt") return pt_wu_hub_faq4_q(inputs)
	if (locale === "ja") return ja_wu_hub_faq4_q(inputs)
	return zh_wu_hub_faq4_q(inputs)
};